import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: block;\n'], ['\n  display: block;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  border-bottom: 2px solid ', ';\n\n  ', ';\n'], ['\n  border-bottom: 2px solid ', ';\n\n  ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  ', ' ', ' ', ' ', ' border: none;\n  color: ', ';\n  box-sizing: border-box;\n  font-size: 12px;\n  font-weight: 600;\n  position: relative;\n  text-align: left;\n  vertical-align: top;\n'], ['\n  ', ' ', ' ', ' ', ' border: none;\n  color: ', ';\n  box-sizing: border-box;\n  font-size: 12px;\n  font-weight: 600;\n  position: relative;\n  text-align: left;\n  vertical-align: top;\n']);

import styled, { css } from 'styled-components';
import { onClickStyle, truncateStyle, arrowsStyle, cellStyle } from './constants';
import { head } from '../theme';

var rankingStyles = css(_templateObject);

export var Head = styled.thead(_templateObject2, head.borderColor, function (_ref) {
  var isRanking = _ref.isRanking;
  return isRanking && rankingStyles;
});

export var HeadCell = styled.th(_templateObject3, function (p) {
  return onClickStyle(p);
}, function (p) {
  return truncateStyle(p);
}, function (p) {
  return arrowsStyle(p);
}, cellStyle, head.textColor);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/dynamic-table/dist/esm/styled/TableHead.js
// module id = 383
// module chunks = 0